module.exports = __webpack_public_path__ + "img/48.5.COD.3e1d773f.png";